import http from '../../../../api/http'

const BASE_URL = '/admin/jobFair';
const API_URL = `${BASE_URL}/applicant`;

// 상시채용관 현황 > 학생/취업준비생 > [TAB]이력서 > 입사지원 목록 조회
function retrieveApplicantListByResumeIdPaging(paramObj) {
  return http.post(`${API_URL}/retrieveApplicantListByResumeIdPaging`, paramObj);
}

// 상시채용관 현황 > 학생/취업준비생 > [TAB]입사지원 > 입사지원 목록 조회
function retrieveAllApplicantListPaging(paramObj) {
  return http.post(`${API_URL}/retrieveAllApplicantListPaging`, paramObj);
}

export default {
  retrieveApplicantListByResumeIdPaging,
  retrieveAllApplicantListPaging,
}

